import { Comment } from '../models/comment';
import { CommentType } from '../models/commenttype.enum';
import { ChangeRequest } from '../models/changerequest';
import { ChangeRequestType } from '../models/change-request-type.enum';

export class UtilService {
  public static getFirstCommentOfTypes(commentList: Comment[], commentTypeList: CommentType[]): Comment[] {
    if (commentList === undefined || commentList === null) {
      return new Array<Comment>();
    }
    let commentType: Array<boolean> = [];
    return commentList.filter(comment => {
      if (commentType[comment.type] === undefined && UtilService.isCommentOfType(comment, commentTypeList)) {
        commentType[comment.type] = true;
        return true;
      }
      return false;
    });
  }

  public static isCommentOfType(comment: Comment, commentTypeList: CommentType[]): boolean {
    for (let commentType of commentTypeList) {
      if (CommentType[commentType] === comment.type.toString()) {
        return true;
      }
    }
    return false;
  }

  public static localToEST(date: Date): Date {
    return new Date(date.getTime() - UtilService.getTimeZoneDiff(date));
  }

  public static checkModifyOrReportBy(authorityChangeRequests: Array<ChangeRequest>) {
    if (!authorityChangeRequests) {
      return null;
    }
    let result = authorityChangeRequests.filter(acr => acr.type !== ChangeRequestType.SHARE && acr.type !== ChangeRequestType.UNSHARE)[0];
    return result ? result : null;
  }
  public static isModifyOrReportBy(authorityChangeRequests: Array<ChangeRequest>) {
    if (this.checkModifyOrReportBy(authorityChangeRequests)) {
      return true;
    }
    return false;
  }

  public static estToLocal(date: Date): Date {
    return new Date(date.getTime() + UtilService.getTimeZoneDiff(date));
  }

  private static getTimeZoneDiff(date: Date): number {
    const estOffset = UtilService.getESTTimeZoneOffset(); // Diff between UTC and EST timezone in minutes
    return (date.getTimezoneOffset() - estOffset) * 60 * 1000;
  }

  private static getESTTimeZoneOffset() {
    const currentDate: Date = new Date();
    const jan: Date = new Date(currentDate.getFullYear(), 0, 1);
    const jul: Date = new Date(currentDate.getFullYear(), 6, 1);
    if (currentDate.getTimezoneOffset() < Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset())) {
      return 240;
    } else {
      return 300;
    }
  }
}
